import { x as trash, y as textSeparator, q as opportunity, z as clock, A as calendar, B as search, C as ellipsisV, i as infoCircle, l as angleDown, D as angleUp, b as angleInlineEnd, E as angleInlineStart, s as spinner, c as check, e as exclamationTriangle, a as exclamation, j as externalLink, h as close } from '../localIcons-9_jhfe7X-DyCR5FH7.js';
import { a as amznAdsStormLogo } from '../brandIcons-B4Znd6XL-D0HNEpMG.js';
import { b as angleDoubleRight, d as angleDoubleLeft } from '../classicIcons-CHpXglL2-uH6-91Kn.js';

const commonIconManifest = {
  close: close.icon,
  'external-link': externalLink.icon,
  exclamation: exclamation.icon,
  'exclamation-triangle': exclamationTriangle.icon,
  check: check.icon,
  spinner: spinner.icon,
  'angle-inline-start': angleInlineStart.icon,
  'angle-inline-end': angleInlineEnd.icon,
  'angle-up': angleUp.icon,
  'angle-down': angleDown.icon,
  'info-circle': infoCircle.icon,
  'amzn-ads-storm-logo': amznAdsStormLogo.icon,
  'ellipsis-v': ellipsisV.icon,
  search: search.icon,
  'angle-double-left': angleDoubleLeft.icon,
  'angle-double-right': angleDoubleRight.icon,
  calendar: calendar.icon,
  clock: clock.icon,
  opportunity: opportunity.icon,
  'text-separator': textSeparator.icon,
  trash: trash.icon
};

export { commonIconManifest as c };
//# sourceMappingURL=commonIconManifest-CqPSXE0Q-CGnO5NBW.js.map
